import FilterChips from "./Chips";

const soilTypes = [
  { label: "Clay", value: "clay" },
  { label: "Loam", value: "loam" },
  { label: "Sandy", value: "sand" },
];

const soilProperties = [
  { label: "Adaptable", value: "adaptable" },
  { label: "Well draining", value: "wellDraining" },
  { label: "Water retaining", value: "waterRetaining" },
];

// cobine soilTypes and soilProperties into one array of just the lables
const options = [...soilTypes, ...soilProperties].map((item) => item.label);

const FilterSoil = ({ value, onChange }) => {
  return (
    <>
      <FilterChips
        title="Soil"
        options={options}
        value={value}
        onChange={onChange}
      />
    </>
  );
};

export default FilterSoil;
